import React, { Component } from 'react';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../Technical.css';

class PublicDesignHandler extends Component {
    render() {
        const exampleCard = process.env.BASE_URL + 'images/technical/example_card.jpg';
        const noImage = process.env.BASE_URL + 'images/technical/noimageavailable.jpg';
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                    Public Design Handler
                </h1> 
                <h2 className="main-subheading">
                            GetPublicDesign.aspx</h2>
                <div className="technical-main-content">                        
                        <h3 className="main-subheading">
                            Overview</h3>
                        <p>
                            The get public design handler is an image source for designs uploaded through the
                            PCS platform. It can be found at:</p>
                        <dl>
                            <dt>Production:</dt><dd className="marginTopdd">https://&lt;prod_environment&gt;/allaboutme/designer/PCS/GetPublicDesign.aspx</dd>
                            <dt>UAT:</dt><dd className="marginTopdd">https://uat.serversidegraphics.com/pcs/designer/GetPublicDesign.aspx</dd>
                        </dl>
                        <h3>Usage</h3>
                        <p>
                            It can be used directly as the src attribute in an html img tag, to display the
                            design on a webpage or an email:</p>
                        <pre >&lt;img src=&quot;https://uat.serversidegraphics.com/pcs/designer/GetPublicDesign.aspx?CardImageId=3em6vla37
			&DesignType=Review&Template=false&Overlay=true&quot; /&gt;</pre>
                        <p>
                            Would produce this:</p>
                        <img src={exampleCard} />
                        <br/><br/>
                        <h3>
                        Design States</h3>
							<ul>
								<li>Denied images cannot be reached.</li>
                                <li>Unchecked images are overlayed with a watermark if optional paramter (overlay) is used.</li>
                                <li>Accepted images have all options.</li>
                            </ul>
                            <h3>
                                Required Parameters</h3>
                                <ul>
                                    <li><b>CardImageId</b>  <p>The 9 digit PCS card image id of the design you wish to view.</p>
                                    </li>
                                </ul>
                                <h3>
                                    Optional Parameters</h3>
                                    <ul>
                                        <li><b>DesignType</b> - The image size returned.<br />
                                                <p>Options:</p>
                                                <ul>
                                                    <li>Design : the full size image without bleed.</li>
                                                    <li>Print: the full size print image including bleed. does NOT include the print template.</li>
                                                    <li>Review : a smaller image, faster to load and suitable for thumbnails etc</li>
                                                    <li>DesignWithTemplate : Deprecated. Same as Design</li>
                                                </ul>
                                                <p>Default:</p>
                                                <ul><li><p>Review is the default value if one is not supplied.</p></li></ul>
                                        </li>
                                        <li><b>Template</b> - Whether or not to display the design template.<br />
                                        <p>Options:</p>
                                                <ul>
                                                    <li>True</li>
                                                    <li>False</li>
                                                </ul>
                                                <p> Default:</p>
                                                <ul><li>By default the design template is shown.</li></ul>
                                        </li>
										<li><b>Overlay</b> - Whether or not to display the overlay.<br />
                                        <p>Options:</p>
                                                <ul>
                                                    <li>True</li>
                                                    <li>False</li>
                                                </ul>
                                                <p>Default:</p>
                                                <ul><li>By default the overlay is not shown.</li></ul>
                                        </li>
                                    </ul>
                                    <h3>
                            Image not available</h3>
                        <p>
                            If the design requested is not found or has been denied at Image Checking then the
                            handler will return a holding image stating that the design is not available. If
                            you need more details on why this is you will need to query the Image Information
                            webservice.</p>
                        <p>
                            Example:</p>
                                <img src={noImage} />
                                <br />
                                <br />
                    </div>
                </div>
                </div>
        )
    }
}

export default PublicDesignHandler;